import { BookingDetails } from './BookingDetails'
import { Order } from './Order'

export class PaymentIntent {
    constructor(
        public id: string,
        public clientSecret: string,
        public bookingDetails?: BookingDetails,
        public confirmationPending?: boolean,
        public order?: Order
    ) { }
}
